import React from 'react';
import { Avatar, Box, IconButton, Typography } from '@mui/material';
import { BackArrowIcon } from 'src/Icons';
import { getServicesCountFromCategory } from 'src/utils/helpers';

export const SelectedCategoryHeader = ({
  category,
  onBack,
}: any) => {
  const servicesCount = getServicesCountFromCategory(category);

  return (<Box
    display="flex"
    flexDirection="row"
    alignItems="center"
    justifyContent="space-between"
    sx={{
      height: '64px',
    }}
  >
    <IconButton
      onClick={onBack}
      sx={{
        width: "48px",
        height: "48px",
        borderRadius: "12px",
        backgroundColor: "#F3F3F3",
        color: "#676767",
        fontSize: "24px",
        marginRight: '16px',
      }}
      disableRipple
    >
      <BackArrowIcon fontSize="inherit" />
    </IconButton>
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
    }}>
      <Avatar
        variant="rounded"
        src={category?.image}
        sx={{
          width: "64px",
          height: "64px",
          borderRadius: "6px",
          marginRight: '8px',
        }}
      />
      <Box>
        <Typography sx={{
          fontWeight: '600',
          color: '#363636',
          fontSize: '21px',
          textTransform: 'uppercase',
        }}>
          {category?.title}
        </Typography>
        <Typography sx={{
          fontWeight: '400',
          color: '#4F4F4F',
          fontSize: '14px',
        }}>
          {`${category?.children?.length} subcategor${category?.children?.length === 1 ? 'y' : 'ies'}`}
        </Typography>
        <Typography sx={{
          fontWeight: '400',
          color: '#4F4F4F',
          fontSize: '14px',
        }}>
          {`${servicesCount} service${servicesCount === 1 ? '' : 's'}`}
        </Typography>
      </Box>
    </Box>
  </Box>)
}